import MDTypography from "../../components/MDTypography";
import {Grid} from "@mui/material";
import MDBox from "../../components/MDBox";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import React, {useContext, useState} from "react";
import {oneTimePassLogin, resetPass} from "./api/PortalCustomerApi";
import {UserContext} from "../../lib/UserProvider";
import {MenuContext} from "../../lib/MenuProvider";

export default function ForgotPasswordForm({callback, handleSuccess}) {
  const [userContext, setUserContext] = useContext(UserContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);

  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [loginError, setLoginError] = useState(null);
  const [loggingIn, setLoggingIn] = useState(false);
  const [showForgotPasswordMessage, setShowForgotPasswordMessage] = useState(false);
  const [codeSent, setCodeSent] = useState(false);

  const forgotPassFn = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const auth = {
      email: email
    };

    setLoginError(null);
    setLoggingIn(true);

    if (codeSent) {
      const auth = {
        email: email,
        code: otp
      };

      let result = await oneTimePassLogin(auth);
      if (result.error) {
        setLoginError(result.message);
      } else {
        setUserContext({...userContext, sessionUser: result, refreshIdentity: true});
        setMenuContext({...menuContext, refreshContext: true})
        callback(true);
        handleSuccess();
      }

      setLoggingIn(false);

      return;

    }

    let result = await resetPass(auth);

    if (result.error) {
      setLoginError(result.message);
      callback(false);
    } else {
      setCodeSent(true);
    }
    setLoggingIn(false);
  }

  const handleChange = (event) => {
    if (event.target.id === 'email') {
      setEmail(event.target.value);
    }
    if (event.target.id === 'otp') {
      setOtp(event.target.value);
    }
  };

  return (<Grid item xs={12}>
      <form onSubmit={forgotPassFn}>

        <center>
          <MDTypography
            variant="h5"
            fontWeight="light"
          >Enter email and we'll send a code</MDTypography>
        </center>
        <Grid container>
          <Grid item xs={12}>
            <MDBox>
              <Grid container p={1}>
                <Grid item xs={12} sm={12}>
                  <div className="form-group">
                    <MDInput type="email"
                             variant="outlined"
                             value={email || ''}
                             onChange={handleChange}
                             autoComplete="username-email"
                             className="form-control" id="email" aria-describedby="emailHelp"
                             placeholder="Enter email"/>
                  </div>
                </Grid>
              </Grid>
              {codeSent &&
                <>
                  <Grid container p={1}>
                    <Grid item xs={12} sm={12}>
                      <div className="form-group">
                        <MDInput type="text"
                                 variant="outlined"
                                 value={otp || ''}
                                 onChange={handleChange}
                                 className="form-control" id="otp" aria-describedby="otpHelp"
                                 placeholder="Enter One Time password"/>
                      </div>
                    </Grid>
                  </Grid>
                  <p className={'mt-2 text-center'}>Please check email for One Time Password</p>
                </>
              }

              <Grid container spacing={3} mt={1}>
                <Grid item xs={12} sm={12}>
                  <MDTypography variant="h5" fontWeight="medium">
                    {loginError && <p className={'text-center text-danger'}>{loginError}</p>}
                    <center>
                      <p>
                        <MDButton type="submit" color="info" disabled={loggingIn}>
                          {codeSent && <>{loggingIn ? 'Signing In...' : 'Sign In'}</>}
                          {!codeSent && <>{loggingIn ? 'Resetting Password...' : 'Reset Password'}</>}
                        </MDButton>
                      </p>
                    </center>
                  </MDTypography>
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </form>
    </Grid>
  )
}